import useLayout from 'hooks/useLayout';
import {FC} from 'react';

export type FieldProps = {
    className?: string;
};

const HorizontalRule: FC<FieldProps> = ({className}) => {
    const {layout} = useLayout();

    const sideBySide = layout === 'sideBySide';

    const hr = <hr className="mt-0 py-0" />;

    if (!sideBySide) {
        return (
            <div className={className} role="presentation">
                {hr}
            </div>
        );
    }

    return (
        <>
            <div />
            <div role="gridcell">{hr}</div>
        </>
    );
};

export default HorizontalRule;
